import { createFileRoute } from "@tanstack/react-router";
import { CreateProcurementCalendarItemPage } from "@/pages/admin-procurement-calendar-create/ui/create-procurement-calendar-item-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/procurement-calendar/new",
)({
  component: CreateProcurementCalendarItemPage,
});
